import { TaskRawStateEnum, TaskStateEnum } from "../../annualWheel/AnnualWheel.types.ts";
import { EntityType } from "../../common/Common.types.ts";
import { DateFieldValue } from "../../common/components/filterPopover/subMenues/DateFieldSubMenu.tsx";
import { DateRangeFilter } from "../../contract/ContractFilter.types.ts";
import { BaseViewModel } from "../../system/systemOverview/SystemOverview.types.ts";

export interface RelatedTaskViewModel {
    id: string;
    relationId: string;
    customId: string;
    title: string;
    deadline: Date;
    responsible: BaseViewModel | undefined;
    additionalEntityInfo: RelatedTaskViewModelAdditionalEntity | undefined;
    isRelation: boolean;
    taskOrigin: TaskOrigin;
    taskState: TaskStateEnum;
    annualWheelActivityId: string | undefined;
}

export interface RelatedTaskViewModelAdditionalEntity {
    additionalEntityId: string;
    additionalEntityName: string;
    entityType: EntityType;
}

export interface RelatedTasksTableModel extends RelatedTaskViewModel {
    deadlineString: string;
    stateString: string;
    entityName: string | undefined;
    entityTypeString: string | undefined;
}

export interface TaskRelationRow {
    taskId: string;
    activityName: string;
    deadline?: Date;
    status: TaskStateEnum;
    groupEntity?: string;
}

export enum TaskOrigin {
    AnnualWheelActivity = 1,
    AdHoc = 2,
    Obligation = 3,
}

export interface RelatedTaskFilterModel {
    taskIds: Array<string>;
    responsibleIds: Array<string>;
    taskStructures: Array<string>;
    deadline: DateFieldValue | undefined;
    taskStates: Array<string>;
}

export function translateTaskOrigin(origin: TaskOrigin, translateString: any) {
    return origin === TaskOrigin.AdHoc
        ? translateString("adHocTask")
        : origin === TaskOrigin.AnnualWheelActivity
          ? translateString("annualWheel")
          : translateString("obligation");
}
